import BaseService from '_services/rest/base';

class ProductService extends BaseService {
  constructor() {
    super();
  }

  deleteFile(id) {
    return this.request(`${this.getUrl()}/file/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteProduct(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/product`;
  }

  getUrlSave(id, url) {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  printQr(id) {
    return this.request(`${this.getUrl()}/qr-code/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  save(product) {
    const meta = this.getUrlSave(product.id, '');
    let formData = new FormData();
    formData = this.setFormData(product, formData);
    formData = this.setFiles(product, formData);
    return this.request(meta.url, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  setFormData(object) {
    const formData = new FormData();
    Object.entries(object).map(field => (
      formData.append(field[0], field[1])
    ));
    return formData;
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.request(`${super.getUrl()}api/file/products`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ProductService();
